<template>
    <div
        class="sports__buttons"
        role="radiogroup"
        :aria-label="ariaLabel"
        @keydown="onKeydown"
    >
        <RadioPill
            v-for="(option, index) in options"
            :key="option.value"
            :ref="(el) => setButtonRef(el, index)"
            :checked="modelValue === option.value"
            :tabindex="getTabindex(index)"
            @select="selectOption(option.value, index)"
        >
            {{ option.label }}
        </RadioPill>
    </div>
</template>

<script>
import RadioPill from './RadioPill.vue';

export default {
    components: {
        RadioPill,
    },
    props: {
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: [ String, Number ],
            default: null,
        },
        ariaLabel: {
            type: String,
            required: true,
        },
    },
    emits: [ 'update:modelValue' ],
    data() {
        return {
            buttonRefs: [],
            focusIndex: 0,
        };
    },
    watch: {
        modelValue() {
            this.syncFocusIndex();
        },
        options() {
            this.buttonRefs = [];
            this.syncFocusIndex();
        },
    },
    mounted() {
        this.syncFocusIndex();
    },
    methods: {
        setButtonRef( el, index ) {
            if ( el ) {
                this.buttonRefs[index] = el.$el;
            }
        },
        syncFocusIndex() {
            const selectedIndex = this.options.findIndex( ( option ) => option.value === this.modelValue );

            if ( selectedIndex >= 0 ) {
                this.focusIndex = selectedIndex;
                return;
            }

            this.focusIndex = 0;
        },
        getTabindex( index ) {
            if ( this.modelValue === null || this.modelValue === '' ) {
                return index === 0 ? 0 : -1;
            }

            return this.options[index].value === this.modelValue ? 0 : -1;
        },
        focusButton( index ) {
            const button = this.buttonRefs[index];

            if ( button ) {
                button.focus();
            }
        },
        selectOption( value, index, shouldFocus = true ) {
            this.focusIndex = index;
            this.$emit( 'update:modelValue', value );

            if ( shouldFocus ) {
                this.$nextTick( () => {
                    this.focusButton( index );
                } );
            }
        },
        moveFocus( direction ) {
            if ( ! this.options.length ) {
                return;
            }

            let nextIndex = this.focusIndex + direction;

            if ( nextIndex < 0 ) {
                nextIndex = this.options.length - 1;
            }

            if ( nextIndex >= this.options.length ) {
                nextIndex = 0;
            }

            this.selectOption( this.options[nextIndex].value, nextIndex );
        },
        onKeydown( event ) {
            switch ( event.key ) {
                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();
                    this.moveFocus( 1 );
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();
                    this.moveFocus( -1 );
                    break;
                case 'Home':
                    event.preventDefault();
                    this.selectOption( this.options[0].value, 0 );
                    break;
                case 'End':
                    event.preventDefault();
                    this.selectOption(
                        this.options[this.options.length - 1].value,
                        this.options.length - 1
                    );
                    break;
                default:
                    break;
            }
        },
    },
};
</script>
